/**
 * 友好連結
 * Created at 2021-10-02 15:56
 * @author teapot
 */
import { useTranslation } from 'react-i18next';
import './index.css';

import title_link from './image/link-view.png';
import title_cn from './image/link-cn.png';
import right_link from './image/link-right.png';
import link1 from './image/link1.png';
import link2 from './image/link2.png';
import link3 from './image/241315877_406683204149037_5521376708609917040_n.png';
import { Image, List } from 'antd';
import { locals } from '../../../i18n';
import LinkusAddress from './LinkusAddress';
const LinkUs = () => {
  const { t } = useTranslation();

  const list = [
    {
      id: 'link1',
      imgs: link1,
      title: t('link_1'),
      url: 'http://ftu.org.hk/',
    },
    {
      id: 'link2',
      imgs: link2,
      title: t('link_2'),
      url: 'https://www.legco.gov.hk/',
    },
    {
      id: 'link3',
      imgs: link3,
      title: t('link_3'),
      url: 'https://www.facebook.com/people/%E9%BA%A5%E7%BE%8E%E5%A8%9F/100044220829949/',
    },
  ];
  return (
    <div className='link'>
      <LinkusAddress></LinkusAddress>
      
      {/* <div className='line'/> */}
      {/* <div className="adviser-title adviser-title-size">{t("nav_us_link")}</div> */}
      <Image src={locals() === 'zh-CN' ? title_cn : title_link} preview={false} className='title-bottom' />

      <List
        dataSource={list}
        grid={{
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 2,
          xl: 2,
          xxl: 3,
        }}
        locale={{ emptyText: t('nodata') }}
        renderItem={(item) => {
          return (
            <List.Item
              onClick={() => {
                window.location.href = item.url;
              }}
            >
              <div className='link-item'>
                <Image src={item.imgs} alt={item.id} preview={false} />
                <div className='link-item-bottom'>
                  <div className='link-item-bottom-item'>
                    <div>{item.title}</div>
                    <div className='link-center'>
                      <div className='link-placeholder' />

                      <Image src={right_link} preview={false} />
                    </div>
                  </div>
                </div>
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default LinkUs;
